import './index.css'
import {IoStarSharp} from 'react-icons/io5'
import {MdLocationOn} from 'react-icons/md'
import {BsBriefcaseFill} from 'react-icons/bs'

const SimilarJobItem = props => {
  const {similarJobItem} = props
  const {
    id,
    title,
    companyLogoUrl,
    employmentType,
    jobDescription,
    location,
    rating,
  } = similarJobItem
  return (
    <li className="sji-bg-container">
      <div className="sji-company-details">
        <img
          alt="similar job company logo"
          className="sji-company-logo"
          src={companyLogoUrl}
        />
        <div>
          <h1 className="sji-company-name">{title}</h1>
          <div className="sji-rating-conainer">
            <IoStarSharp color="#fbbf24" size="30" />
            <p className="sji-company-rating">{rating}</p>
          </div>
        </div>
      </div>
      <div className="sji-description-container">
        <h1 className="sji-description-header">Description</h1>
        <p className="sji-job-description">{jobDescription}</p>
      </div>
      <div className="sji-company-location-details">
        <div className="center">
          <div className="center sji-location-details">
            <MdLocationOn size="20" />
            <p className="sji-location-item">{location}</p>
          </div>
          <div className="center">
            <BsBriefcaseFill size="20" />
            <p className="sji-employment-item">{employmentType}</p>
          </div>
        </div>
      </div>
    </li>
  )
}
export default SimilarJobItem
